<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div
      v-if="!blockList.length"
      class="box-body"
    >
      無選擇區，請新增
    </div>

    <div
      v-else
      class="box-body"
    >
      <div class="col-xs-12">
        <div class="inline-block pull-left">
          <h4 class="pull-left">
            品項選擇區
          </h4>
        </div>

        <div>
          <button
            class="btn btn-danger inline-block m-y-10 pull-right"
            data-toggle="modal"
            data-target="#delModal"
            @click="delModalOpen"
          >
            刪除
          </button>

          <button
            class="btn btn-black btn-default inline-block m-r-10 m-y-10 pull-right"
            @click="gotoCrBlocks"
          >
            新增
          </button>

          <button
            class="btn btn-black btn-default inline-block m-r-10 m-y-10 pull-right"
            data-toggle="modal"
            @click="show.easy = !show.easy"
          >
            <span v-if="!show.easy">簡易</span>

            <span v-else>進階</span>
          </button>

          <button
            class="btn btn-primary m-r-10 m-y-10 pull-right"
            data-toggle="modal"
            data-target="#choseModal"
            @click="clearAllActive(blockChoseList)"
          >
            複製商品到其他選擇區
          </button>
        </div>
      </div>

      <div class="col-xs-12">
        <div
          ref="selectBlock"
          class="bg-light-gray col-md-2 col-xs-12 select-element-block text-left"
        >
          <div
            v-for="(block, index) in blockList"
            :key="block.item_id"
            class="select-element"
            :class="{'active': curId === block.item_id}"
            :disabled="isLoad || curId === block.item_id"
            @click="() => clickBlock(block, index)"
          >
            <span class="text-w-600">{{ block.name }}</span>

            <small style="opacity: .7;">&nbsp;&nbsp;{{ block.remark }}</small>
          </div>
        </div>

        <div v-show="!isLoad" class="col-md-10 col-xs-12">
          <div class="box-body col-xs-12 form menu-form">
            <div class="col-md-6 col-xs-12 p-r-5">
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>品項選擇區名稱</span>

                <input
                  v-model="blockInfo.name"
                  class="form-control"
                  placeholder=""
                  type="text"
                  maxlength="32"
                >
              </div>

              <br>

              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>排序</span>

                <input
                  ref="sort1"
                  v-model="blockInfo.sort"
                  class="form-control"
                  placeholder=""
                  type="text"
                  maxlength="4"
                  @keyup="veritySort"
                >
              </div>

              <br>

              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>必選項目</span>

                <div
                  class="h-38 radio text-left"
                  style="border-left: 1px solid #d2d6de;"
                >
                  <label class="m-l-15">
                    <input
                      v-model="blockInfo.is_mandatory"
                      type="radio"
                      name="mandatoryRadio"
                      :value="1"
                      style="top: 12px;"
                    >

                    <div style="top: 8px; left: 8px;">是</div>
                  </label>

                  <label class="m-l-15">
                    <input
                      v-model="blockInfo.is_mandatory"
                      type="radio"
                      name="mandatoryRadio"
                      :value="0"
                      style="top: 12px;"
                    >

                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>

              <br>

              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>

                  選購數量<br></span>

                <input
                  ref="minLimit"
                  v-model="blockInfo.min_limit"
                  style="width: calc(50% - 10px)"
                  class="c-auto form-control"
                  placeholder="0為無上限"
                  type="text"
                  maxlength="9"
                  @keyup="verityMinLimit"
                >

                <span
                  class="pull-left"
                  style="line-height: 38px; width: 20px"
                >~</span>

                <input
                  ref="maxLimit"
                  v-model="blockInfo.max_limit"
                  style="width: calc(50% - 10px)"
                  class="c-auto form-control"
                  placeholder="0為無上限"
                  type="text"
                  maxlength="9"
                  @keyup="verityMaxLimit"
                >
              </div>

              <br>

              <div class="input-group">
                <span class="input-group-addon">備註</span>

                <input
                  v-model="blockInfo.remark"
                  class="form-control"
                  placeholder=""
                  type="text"
                  maxlength="45"
                >
              </div>

              <br>
            </div>

            <div
              v-show="!show.easy"
              class="col-md-6 col-xs-12 p-l-5"
            >
              <div class="input-group">
                <span class="input-group-addon">描述</span>

                <input
                  v-model="blockInfo.description"
                  class="form-control"
                  placeholder=""
                  type="text"
                  maxlength="45"
                >
              </div>

              <br>

              <div class="input-group">
                <span class="input-group-addon">商品料號</span>

                <input
                  v-model="blockInfo.vendor_custom_id"
                  class="form-control"
                  placeholder=""
                  type="text"
                  maxlength="30"
                >
              </div>

              <br>

              <div class="input-group">
                <span class="input-group-addon">套餐內的商品</span>

                <button
                  class="btn btn-default form-control"
                  style="width: auto"
                  data-toggle="modal"
                  data-target="#choseMoneyModal"
                >
                  變更套餐內商品資訊
                </button>
              </div>

              <br>
            </div>

            <div class="col-xs-12">
              <div class="input-group">
                <span class="input-group-addon">商品</span>

                <div
                  class="form-control text-left"
                  style="min-height: 60px"
                >
                  <button
                    class="btn btn-black btn-default inline-block m-y-10"
                    data-toggle="modal"
                    data-target="#choseProdModal"
                    style="position: absolute; right: 10px; top: 0px; z-index: 3;"
                  >
                    選擇商品
                  </button>

                  <div class="option-left-block">
                    <div
                      v-for="prod in productList"
                      :key="prod.item_id"
                      v-if="prod.active"
                      class="inline-block m-r-10 option-chose"
                      style="margin: 5px"
                    >
                      {{ prod.name }}
                    </div>
                  </div>
                </div>
                <!-- <input class="form-control" placeholder="" type="text" v-model="adjustInfo.calorie" @keyup="verityCalorie()" ref="calorie1"> -->
              </div>

              <br>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-footer text-center">
      <button
        class="btn btn-default"
        @click="gotoOut"
      >
        返回
      </button>

      <button
        v-if="!blockList.length"
        class="btn btn-black btn-default"
        @click="gotoCrBlocks"
      >
        新增
      </button>

      <button
        v-else
        class="btn btn-success"
        @click="checkInputEmpty"
      >
        儲存
      </button>
    </div>

    <br>

    <CModal
      :element-list="productList"
      :option="choseProduct"
      :show-money="true"
      @trigger="trigger"
    />

    <CModal
      :element-list="blockChoseListWithoutCurrent"
      :option="choseOption"
      @trigger="trigger"
    />

    <MModal
      class="text-left"
      :option="delOption"
      @trigger="trigger"
    />

    <PIModal
      :hide-cancel="true"
      :product-list="productList"
      :option="moneyOption"
      @trigger="trigger"
    />
  </div>
</template>

<script>
import matcherModal from '../../../elements/Modal.vue'
import $ from 'jquery'
import AdjustModal from './AdjustModal.vue'
import OptionModal from './OptionModal.vue'
import { mapActions, mapGetters } from 'vuex'
import ChoseModal from '../../../elements/ChooseModal.vue'
import productInfoModal from '../../../elements/ProductInfoModal.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'CrBlockTemp',

  components: {
    AdjustModal: AdjustModal,
    OptionModal: OptionModal,
    CModal: ChoseModal,
    MModal: matcherModal,
    PIModal: productInfoModal
  },

  extends: NdExtendHandleMenu,

  props: {
    'info': {
      type: Object
    }
  },

  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },

      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },

      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },

      count: 20,
      maxTotal: 0,
      blockList: [],
      productList: [],
      packageList: [],
      blockInfo: {
        name: '',
        sort: 1,
        is_mandatory: 1,
        category_custom_id: '',
        description: '',
        remark: '',
        min_limit: '0',
        max_limit: '0'
      },

      choseProduct: {
        // 配料modal資料
        id: 'choseProdModal',
        title: '選擇商品',
        event: 'chooseProduct'
      },

      chosePackage: {
        // 配料modal資料
        id: 'chosePackModal',
        title: '選擇套餐',
        event: 'choosePackage'
      },

      curId: 0,
      oldInfo: {},
      defaultIndex: 1,
      isLoad: false,
      delOption: {
        id: 'delModal',
        title: '刪除商品分類',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'del'
          }
        ]
      },

      moneyOption: {
        // 配料money modal資料
        id: 'choseMoneyModal',
        title: '更改商品在套餐內的金額',
        event: 'chooseMoney'
      },

      blockChoseList: [],
      choseOption: {
        // 配料modal資料
        id: 'choseModal',
        title: '選擇選擇區',
        event: 'chooseElement'
      }
    }
  },

  methods: {
    ...mapActions(['setUpAdjust', 'setModal']),

    toggle () {
      $(this.$refs.infoAdjustModal).css('display')
    },

    maxAmount (max) {
      if (!max) return '無限制'
      else return max
    },

    getSubType (type) {
      if (type === 10) {
        return '大小'
      } else if (type === 20) {
        return '容器'
      } else if (type === 30) {
        return '甜度'
      } else if (type === 40) {
        return '溫度'
      } else {
        return '其他'
      }
    },

    getPriceType (type) {
      if (type === 1) return '免稅價格'
      else if (type === 3) return '含稅價格'
    },

    veritySort () {
      var e
      if (this.state === 1) e = $(this.$refs.sort1)
      else if (this.state === 3) e = $(this.$refs.sort3)
      this.adjustInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },

    verityMinLimit () {
      var e = $(this.$refs.minLimit)
      this.blockInfo.min_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },

    verityMaxLimit () {
      var e = $(this.$refs.maxLimit)
      this.blockInfo.max_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },

    verityPrice () {
      var e
      if (this.state === 1) e = $(this.$refs.price1)
      else if (this.state === 3) e = $(this.$refs.price3)
      this.adjustInfo.price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },

    verityCalorie () {
      var e
      if (this.state === 1) e = $(this.$refs.calorie1)
      else if (this.state === 3) e = $(this.$refs.calorie3)
      this.adjustInfo.calorie = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },

    getAdjustInfo () {
      const url = this.base + this.id + '/adjust/' + this.adjustId
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.adjustInfo = response.data.adjust
        }
      })
    },

    checkInputEmpty () {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫選擇區名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.upBlock()
        return true
      }
    },

    delAdjust () {
      const url = this.base + this.id + '/adjust?adjust_id=' + this.adjustId
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功刪除調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.editState = false
          const id = this.modalId
          $('#' + id).modal('toggle')
          this.setUpAdjust(true)
        }
      })
    },

    clearData () {
      this.blockInfo = {
        name: '',
        sort: 1,
        category_custom_id: '',
        description: '',
        remark: '',
        min_limit: '0',
        max_limit: '0'
      }
    },

    gotoCrBlocks () {
      console.log('gotoCrBlocks')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuBlockCreate'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'crBlocks'
      }

      this.$router.push({ name, params })
    },

    gotoOut () {
      this.$router.go(-1)
    },

    gotoNext () {
      this.$router.push('/upProduct/' + this.brandId)
    },

    trigger (event) {
      if (event === 'del') {
        this.del(this.blockInfo.name)
      } else if (event === 'chooseElement') {
        this.copyProductContent()
      }
    },

    del (delName) {
      const url = this.base + this.id + '/block?block_id=' + this.blockInfo.block_id
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuBlock('delete')
        }
      })
    },

    getMenuBlock (type, cId) {
      this.blockList = []
      const url = this.base + this.id + '/block/briefList?type=0'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const packageList = response.data.list
          packageList.forEach((pa) => {
            pa.child_list.forEach((block) => {
              this.blockList.push(block)
            })
          })
          if ((this.blockList.length && !this.curId) || type === 'delete') {
            if (this.$route.query.cId) this.curId = parseInt(this.$route.query.cId, 10)
            else this.curId = this.blockList[0].item_id
          }
          if (type === 'clickOther') {
            this.curId = cId
            const scrollHeight = $(this.$refs.selectBlock).height()
            $(this.$refs.selectBlock).scrollTop(scrollHeight, 200)
          }
          this.blockList = this.blockList.reverse()
          // 選擇區設定
          const categoryList = response.data.list
          categoryList.forEach((element) => {
            const blockList = element.child_list
            blockList.forEach((element) => {
              this.blockChoseList.push(element)
            })
          })
          this.getMenuProduct()
        }
      })
    },

    getMenuProduct () {
      this.productList = []
      const url = this.base + this.id + '/product/briefList?type=0'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            const categoryList = response.data.list
            categoryList.forEach((element) => {
              const productList = element.child_list
              productList.forEach((prod) => {
                prod.active = false
                prod.sort = ''
                prod.newPrice = ''
                prod.is_mandatory = ''
                prod.min_limit = ''
                prod.max_limit = ''
                prod.is_default = ''
                this.productList.push(prod)
              })
            })
            if (this.curId) this.getBlock()
          } else if (this.curId) this.getBlock()
        }
      })
    },

    copyBlock () {
      const url = this.base + this.id + '/block/' + this.curId + '/duplicate'
      this.getDataH('post', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功複製選擇區',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuBlock('clickOther', response.data.new_block_id)
        }
      })
    },

    getBlock () {
      const url = this.base + this.id + '/block/' + this.curId
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          $.each(response.data.block, (index, value) => {
            this.$set(this.oldInfo, index, value)
          })
          this.blockInfo = response.data.block
          if (!this.blockInfo.sort) {
            this.blockInfo.sort = this.defaultIndex
            this.upBlock('sort')
          }
          this.setActiveProduct()
        }
      })
    },

    clickBlock (block, index) {
      this.isLoad = true
      this.curId = block.item_id
      this.defaultIndex = index + 1
      this.getMenuProduct()
    },

    copyProductContent () {
      let bActiveList = []
      this.blockChoseList.forEach((block) => {
        if (block.active) {
          bActiveList.push(block)
        }
      })
      for (let i = 0; i < bActiveList.length; i++) {
        if (i === bActiveList.length - 1) this.upProduct(bActiveList[i].item_id, true)
        else this.upProduct(bActiveList[i].item_id, false)
      }
    },

    upProduct (cId, isLast) {
      let data = {}
      let pList = []
      this.productList.forEach((element) => {
        let obj = {
          product_id: element.item_id
        }
        if (element.newPrice) obj.price = element.newPrice
        if (element.sort) obj.sort = element.sort
        if (element.is_mandatory) obj.is_mandatory = element.is_mandatory
        if (element.min_limit) obj.min_limit = element.min_limit
        if (element.max_limit) obj.max_limit = element.max_limit
        if (element.active) pList.push(obj)
      })
      data.product_list = pList
      const url = this.base + this.id + '/block/' + cId
      if (JSON.stringify(data) !== '{}') {
        this.getDataH('put', url, data, (response) => {
          if (response.data.status === 200) {
            if (isLast) {
              this.$notify({
                title: '提醒',
                text: '已複製商品內容到其他選擇區',
                duration: 3000,
                type: 'success',
                width: 400
              })
            }
            this.clearAllActive(this.blockList)
          }
        })
      }
    },

    upBlock (type) {
      const url = this.base + this.id + '/block/' + this.curId
      let data = {}
      let bInfo = this.blockInfo
      let oldInfo = this.oldInfo
      if (type === 'sort') {
        data.sort = bInfo.sort
      } else {
        let pList = []
        this.productList.forEach((element) => {
          let obj = {
            product_id: element.item_id
          }
          if (element.newPrice) obj.price = element.newPrice
          if (element.sort) obj.sort = element.sort
          if (element.is_default) obj.is_default = element.is_default
          if (element.is_mandatory) obj.is_mandatory = element.is_mandatory
          if (element.min_limit) obj.min_limit = element.min_limit
          if (element.max_limit) obj.max_limit = element.max_limit
          if (element.active) pList.push(obj)
        })
        let cList = []
        bInfo.product_list.forEach((element) => {
          cList.push(element.product_id)
        })
        if (bInfo.sort !== oldInfo.sort) data.sort = bInfo.sort
        if (bInfo.name !== oldInfo.name) data.name = bInfo.name
        if (bInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = bInfo.vendor_custom_id
        if (bInfo.description !== oldInfo.description) data.description = bInfo.description
        if (bInfo.remark !== oldInfo.remark) data.remark = bInfo.remark
        if (bInfo.is_mandatory !== oldInfo.is_mandatory) data.is_mandatory = bInfo.is_mandatory
        if (bInfo.min_limit !== oldInfo.min_limit) data.min_limit = bInfo.min_limit
        if (bInfo.max_limit !== oldInfo.max_limit) data.max_limit = bInfo.max_limit
        data.product_list = pList
      }
      if (JSON.stringify(data) !== '{}') {
        this.getDataH('put', url, data, (response) => {
          if (response.data.status === 200) {
            if (!type) {
              this.$notify({
                title: '提醒',
                text: '已更新' + bInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              })
            }
            if (bInfo.name !== oldInfo.name) {
              this.getMenuBlock('reload', bInfo.block_id)
            }
          }
        })
      }
    },

    setActiveProduct () {
      if (this.blockInfo.product_list.length) {
        this.blockInfo.product_list.forEach((o) => {
          this.productList.find((prod) => {
            if (prod.item_id === o.product_id) {
              prod.active = true
              prod.newPrice = o.price
              prod.price = o.price
              if (o.min_limit || o.min_limit === 0) prod.min_limit = o.min_limit
              if (o.max_limit || o.max_limit === 0) prod.max_limit = o.max_limit
              if (o.sort) prod.sort = o.sort
              if (o.is_mandatory || o.is_mandatory === 0) prod.is_mandatory = o.is_mandatory
              if (o.is_default || o.is_default === 0) prod.is_default = o.is_default
            }
          })
          this.isLoad = false
        })
      } else {
        this.isLoad = false
      }
    },

    delModalOpen () {
      this.delOption.title = `刪除${this.blockInfo.name}`
    },

    clearAllActive (list) {
      list.forEach((element) => {
        this.$set(element, 'active', false)
      })
    }
  },

  created () {
    this.getMenuBlock()
  },

  computed: {
    ...mapGetters(['getUpAdjust', 'getModal', 'getRoleType']),

    allInput () {
      var info = this.blockInfo
      return {
        name: this.checkInput(info.name),
        sort: this.checkInput(info.sort),
        vendor_custom_id: this.checkInput(info.vendor_custom_id),
        description: this.checkInput(info.description),
        remark: this.checkInput(info.remark),
        min_limit: this.checkInput(info.min_limit),
        max_limit: this.checkInput(info.max_limit)
      }
    },

    getDataH () {
      return this.$parent.getDataH
    },

    checkInput () {
      return this.$parent.checkInput
    },

    productNew () {
      var product = this.product
      return product
    },

    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    },

    blockChoseListWithoutCurrent () {
      return this.blockChoseList.filter(item => item.item_id !== this.curId)
    }
  }
}
</script>

<style lang="sass" scoped>
$light-gray: rgb(238, 238, 238)
$primary-color: #3c8dbc

.btn-black, .btn-black:hover, .btn-black:focus, .btn-black:active, .btn-black:active:focus
  border: 1px solid #333333
.m-r-10
  margin-right: 10px
.p-r-5
  padding-right: 5px
.p-l-5
  padding-left: 5px
.box-body.menu-form
  left: 0
  width: auto
  padding: 0px 10px
.btn.disabled, .btn[disabled], fieldset[disabled] .btn
  cursor: auto
  opacity: 1
.bg-light-gray
  background: $light-gray
.select-element
  padding: 10px 15px
  cursor: pointer
  border-bottom: 2px solid #ddd
.select-element:last-child
  border-bottom: 0px
.select-element:hover, .select-element.active
  background: $primary-color
  color: #fff
.select-element-block
  margin-bottom: 10px
  max-height: calc(100vh - 360px)
  overflow: scroll
.option-chose
  background: $primary-color
  color: #ffffff
  padding: 6px 12px
.option-left-block
  width: calc(100% - 95px)
@media screen and (max-width: 767px)
  .select-element
    padding: 5px 15px
    font-size: 16px
  .select-element-block
    margin-left: 10px
    margin-right: 10px
    height: 30vh
  .option-left-block
    width: 100%
    padding-top: 45px
</style>



// WEBPACK FOOTER //
// CrBlockTemp.vue?2b51fde6